import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"z-0 circlePosition w-[390px] h-[390px] bg-[#dcebfc] rounded-[100%] absolute z-1 top-[50%] left-[30%] translate-x-[-50%] translate-y-[-50%] blur-[99px]\"></div><div class=\"z-0 circlePosition w-[390px] h-[390px] bg-[#ffcfdc] rounded-[100%] absolute z-1 top-[90%] left-[50%] translate-x-[-50%] translate-y-[-0%] blur-[99px]\"></div><div class=\"z-20 flex flex-col\"><div class=\"flex justify-center z-10 text-xl text-3xl\" style=\"font-family:&#39;Pacifico&#39;, cursive;\"><p class=\"\">Votre service de réservation.</p></div><div class=\"z-20 flex justify-center\"><p>Une solution, un logiciel.</p></div></div>", 3)
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "z-20 py-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "z-20 m-3 text-xl font-bold lg:mx-4" }, " Récemment ajoutés:", -1)
const _hoisted_9 = { class: "grid md:grid-cols-3 gap-4 mx-4 mb-1" }

import { onMounted, ref } from 'vue'
  import { useCompaniesStore } from '../stores/CompaniesStore'
  import ModalHome from '@/components/Home/ModalHome.vue';
  import CompanyCard from '@/components/Home/CompanyCard.vue';
  import { storeToRefs } from 'pinia'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

  const { getCompanies } = useCompaniesStore()
  const { companiesList} = storeToRefs(useCompaniesStore())

  onMounted( () => {
    getCompanies();
  } )
  

  const isModalVisible = ref(false);
  function openModal() {
    console.log("Hello");
    isModalVisible.value = true;
  }
  const closeModal = () => {
    isModalVisible.value = false;
  };
  let modalMessage= ref("")

  // let isVisible= false;
  // function toggleModal(){
  //   isVisible =!isVisible;
  // }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(ModalHome, {
        "is-visible": isModalVisible.value,
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createElementVNode("span", {
              textContent: _toDisplayString(_unref(modalMessage))
            }, null, 8, _hoisted_2)
          ])
        ]),
        _: 1
      }, 8, ["is-visible"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companiesList), (company) => {
            return (_openBlock(), _createBlock(CompanyCard, {
              class: "z-20",
              key: company.companyId,
              company: company
            }, null, 8, ["company"]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})